import { inject, Provider } from '@angular/core'

import { MarkedOptions, Renderer } from 'marked'
import { MARKED_OPTIONS } from 'ngx-markdown'

import { AuthStore } from '@yoshu-lib/core/auth/auth.store'

import { environment } from '@forvia/env/environment'

export const provideMarkdownCustomRenderer = (): Provider => {
  return {
    provide: MARKED_OPTIONS,
    useFactory: () => {
      const authStore = inject(AuthStore)
      const authToken = authStore.token()

      const renderer = new Renderer()

      renderer.image = ({ href, title, text }): string => {
        let finalSrc = href

        if (href.startsWith('/v1/blobs/')) {
          finalSrc = `${environment.socketUrl}${href}?token=${authToken}`
        }

        const escapedTitle = title ? ` title="${title}"` : ''
        const escapedAlt = text ? ` alt="${text}"` : ''

        const html = `<img src="${finalSrc}"${escapedAlt}${escapedTitle} />`
        return `<div class="markdown-image-container">${html}</div>`
      }

      const options: MarkedOptions = {
        renderer,
        gfm: true,
        breaks: true
      }

      return options
    }
  }
}
